
<ion-content>
  <ion-list *ngIf="list.length > 0">
    <ion-item *ngFor="let item of list" [title]="item.description">
      <ion-checkbox [(ngModel)]="item.checked" slot="start" labelPlacement="end" (ngModelChange)="itemChecked(item)">
        {{item.description}}
      </ion-checkbox>
    </ion-item>
  </ion-list>

  <p *ngIf="list.length == 0" class="no-content">Keine Anhänge</p>

</ion-content>